module.exports = __webpack_public_path__ + "static/media/blog1.9313c5c1.jpg";